import React from "react";
import { connect } from "react-redux";
import _ from 'lodash';
import * as types from "../../constants/actionTypes";
import * as d from "../../reducers/domainReducer";
import Logo from "./Logo";
import ActiveUser from "./ActiveUser";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

/**
 * Page header component.
 * 
 * @returns {any} header.
 */
class Header extends React.Component {
    constructor(props) {
        super(props);
        const { currentPharmacyUser, currentMyChartUser } = this.props;
        this.state = { activeUser: currentPharmacyUser ? currentPharmacyUser : currentMyChartUser, pageScrolledClass: "" };
        this.throttle = _.throttle(this.handleScroll.bind(this), 150, { maxWait: 100 });
    }

    componentDidMount() {
        this.historyUnlisten = this.props.history.listen((location, action) => {
            if (!this.props.stayOnIncompleteForm && window.userToSwitch && this.callback) {
                this.callback(window.userToSwitch, this);
                this.callback = null;
            }
            this.props.resetStayOnIncompleteForm();
        });

        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', this.throttle);
            window.addEventListener('resize', this.resizeThrottle);
        }

        logUI("UI.Header.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('scroll', this.throttle);
        }

        if (this.historyUnlisten) {
            this.historyUnlisten();
        }
    }

    handleScroll(event) {
        if (typeof window !== 'undefined') {
            const scrollY = window.pageYOffset;
            const topOffsetHeight = 110; // Height of header plus margin bottom

            if (scrollY > topOffsetHeight) {
                if ((this.state.scrollTop + topOffsetHeight) < scrollY) {
                    this.setState({
                        scrollTop: scrollY,
                        pageScrolledClass: " page-scrolled-down"
                    });
                }
                else if ((this.state.scrollTop - topOffsetHeight) > scrollY) {
                    this.setState({
                        scrollTop: scrollY,
                        pageScrolledClass: " page-scrolled-up"
                    });
                }
            }
            else {
                this.setState({
                    scrollTop: scrollY,
                    pageScrolledClass: ""
                });
            }
        }
    }

    getPatientPhoto() {
        if (window && window.serverData.data.enablePatientPhoto && this.props.hasMyChart) {
            this.props.getPatientPhoto();
        }
    }

    render() {
        const { primaryUser, currentMyChartUser, currentPharmacyUser, dateTimeOffset, hasAAL, history, serverData, hideBannerOnCrash, infoForUpdateMobileNo } = this.props;
        const { activeUser } = this.state;
        const patientPhoto = this.props.patientPhoto && this.props.patientPhoto.response ? this.props.patientPhoto.response.data : null;   
        const children = React.Children.map(this.props.children, (child, index) => {
            return React.cloneElement(child, {
                index,
                opacity: this.state.opacity
            });
        });
        //if (!primaryUser) {
        //    return (
        //        <HeaderView loginStatus={loginStatus} onLogoutClick={onLogoutClick} />
        //    );
        //}

        return (
            //<HeaderView
            //    serverData={serverData} loginStatus={loginStatus} proxyListLoading={proxyListLoading}
            //    primaryUser={primaryUser} currentUser={currentUser} users={proxyList}
            //    onUserClick={onUserClick} onLogoutClick={onLogoutClick}
            ///>   
            <React.Fragment>
                <div ref={(el) => (this.header = el)} className={`container-fluid header proxy-closed${infoForUpdateMobileNo ? " backdrop-updatemobilenoinfo-enabled" : ""}` + this.state.pageScrolledClass}>
                    <div className="row">
                        <div className="col-12 header-proxy-dropdown">
                            <div className="row header__main align-items-center">
                                <Logo containerClass="col-4 col-sm-6 header__logo" currentPharmacyUser={currentPharmacyUser} />
                                {/*middleSection*/}
                                <div className="col-8 col-sm-6 header__active-users">
                                    <ActiveUser
                                        containerClass="active-users-container"
                                        dateTimeOffset={dateTimeOffset}
                                        patientPhoto={patientPhoto}
                                    />
                                </div>
                            </div>
                            {/*<div className="row header__current-users--mobile">
                                <div className="col-12">
                                    <ActiveUser mobileView primaryUser={primaryUser} activeUser={activeUser} patientPhoto={patientPhoto} />
                                </div>
                            </div>*/}
                        </div>
                    </div>
                </div>
                {children}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        dateTimeOffset: state.domain.dto,
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth",
        hasMyChart: !state.common.epicEHRDown && state.domain.hm,
        rxDown: state.common.rxDown,
        hasPharmacy: state.domain.hp,
        history: state.session.history,
        stayOnIncompleteForm: state.common.stayOnIncompleteForm,
        patientPhoto: state.portal.patientPhoto,
        hasAAL: !state.common.aalDown && state.domain.aal,
        hideBannerOnCrash: state.common.hideBannerOnCrash,
        infoForUpdateMobileNo: state.session.infoForUpdateMobileNo,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetStayOnIncompleteForm: () => dispatch({ type: types.STAY_ON_INCOMPLETE_FORM, stay: false }),
        updateShowBanner: () => dispatch({ type: types.GRAPHIC_BANNER_UPDATE })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);